
/* eslint-disable */
import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import '@styles/consulta-pronto-socorro.css';

class CemigModal extends Component {

    constructor(props) {
        super(props);

        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown, false);
    }

    handleKeyDown(event) {
        if (event.key === 'Enter' && this.props.activeAccordion == '3' && this.props.isOpened && this.props.enterKeyPress) {
            event.preventDefault();
            this.props.enterKeyPress();
        }
    }

    render() {
        return (
            <Modal 
                id={this.props.modalId? this.props.modalId : ''} 
                show={this.props.isOpened} 
                style={{ marginTop: '10%' }}
                onEntered={this.props.onOpenModal? this.props.onOpenModal : () => {}}
            >
                <Modal.Header style={{ backgroundColor: '#f5f5f6', borderTopLeftRadius: 6, borderTopRightRadius: 6 }}>
                    <Modal.Title className={"form-header-title"}>
                        {this.props.title}
                        <div onClick={() => {this.props.close()}} style={{ float: "right", cursor: 'pointer' }}>✕</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ margin: '10px 20px 20px' }}>
                    {this.props.content}
                </Modal.Body>
            </Modal>
        );
    }
}

export default CemigModal